<template>
  <div style="border: 1px solid #333; padding: 1rem; margin-bottom: 1rem; margin: 1rem -1rem;">
    <p>
      <strong>{{ $t("contract.special_saving.headline") }}</strong>
    </p>

    <p>
      <span>
        {{ $t("contract.special_saving.paragraphs.first") }}
      </span>
    </p>

    <p class="user-output">
        {{
          $t("contract.special_saving.paragraphs.second", {
            savingPercent: specialSaving.savingPercent,
          })
        }}
    </p>

    <p>
      <span>
        {{ $t("contract.special_saving.paragraphs.third") }}
      </span>
    </p>

    <p>
      <span v-if="specialSaving.deal === 'one'" class="user-output">{{
        $t("contract.special_saving.deals.first")
      }}</span>
      <span v-else-if="specialSaving.deal === 'two'" class="user-output">{{
        $t("contract.special_saving.deals.second")
      }}</span>
    </p>

    <p>
      <span>
        {{
          $t("contract.special_saving.paragraphs.fourth")
        }}
      </span>
    </p>
  </div>
</template>

<script>
export default {
  computed: {
    specialSaving() {
      return this.$store.state.contract.special_saving;
    },
  },
};
</script>
